import React from "react";
import { Link } from "react-router-dom";

// corporate items
const corporate_data = [
  {
    id:1,
    img:'/assets/img/project/item-1.jpg',
    tag:"Business",
    title:"USSD"
  },
  {
    id:2,
    img:'/assets/img/project/item-2.jpg',
    tag:"Business",
    title:"Shortcodes"
  },
  {
    id:3,
    img:'/assets/img/project/item-3.jpg',
    tag:"Business",
    title:"Intern program"
  },
]

const CorporateItems = () => {
  return (
    <>
      <div className="project-page-list pt-140 pb-90">
        <div className="container">
          <div className="row">
            {corporate_data.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 col-12">
              <div className="pj-list-item mb-50">
                <div className="pj-list__img">
                  <img src={item.img} alt="" />
                </div>
                <span>
                  <a href="https://onfonmedia.com">{item.tag}</a>
                </span>
                <h4 className="pj-list__title">
                  <Link to="/corporate-details">{item.title}</Link>
                </h4>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateItems;
